(function () {
  function render(cart) {
    var el = document.querySelector('[data-fspb]');
    if (!el) return;

    var threshold = parseInt(el.dataset.threshold, 10);
    var total = cart.total_price;

    if (total < threshold) {
      var left = theme.Currency.formatMoney(threshold - total, theme.settings.moneyFormat);
      var txt = el.dataset.buyMoreText.replace('$amount$', '<span>' + left + '</span>');
      el.innerHTML =
        '<p class="freeship">' + txt + '</p>' +
        '<meter min="0" max="' + threshold + '" optimum="' + threshold +
        '" low="' + Math.floor(threshold / 2) + '" high="' + (threshold - 1) +
        '" value="' + total + '"></meter>';
    } else {
      el.innerHTML = '<p class="freeship">' + el.dataset.freeText + '</p>';
    }
  }

  function refresh() {
    return theme.cart.getCart().then(render).catch(function () {});
  }

  // Add to cart (drawer) — server already updated, pull fresh totals
  document.addEventListener('ajaxProduct:added', refresh);

  // Qty change / remove (drawer + cart page) — cart object is on the event
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      render(evt.detail.cart);
    } else {
      refresh();
    }
  });

  // Safety sync once theme is ready
  document.addEventListener('page:loaded', refresh);
})();